const CART_KEY = "lvup-cart";

export const cartRead = () => {
  try {
    const list = JSON.parse(localStorage.getItem(CART_KEY) || "[]");
    if (!Array.isArray(list)) return [];
    return list
      .filter((e) => e && typeof e === "object" && (e.type === "game" || e.type === "mobile") && e.package && typeof e.package === "object" && typeof e.id === "string" && e.id)
      .map((e) => ({ ...e, qty: Math.min(99, Math.floor(Number(e.qty))) }))
      .filter((e) => e.qty > 0);
  } catch (e) {
    return [];
  }
};

const cartWrite = (list) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(list));
  } catch (e) {}
  try {
    window.dispatchEvent(new Event("cart-change"));
  } catch (e) {}
  return list;
};

export const cartCount = () => cartRead().reduce((s, e) => s + (Number(e.qty) || 0), 0);

export const cartAdd = ({ type, source, gameIndex, gameName, id_game, package: pkg }) => {
  const list = cartRead();
  const same = list.find(
    (e) =>
      e.type === type &&
      e.source === source &&
      e.gameIndex === gameIndex &&
      e.id_game === id_game &&
      e.package?.name === pkg?.name &&
      e.package?.new_price === pkg?.new_price
  );
  if (same) same.qty = (Number(same.qty) || 0) + 1;
  else list.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, type, source, gameIndex, gameName, id_game, package: pkg, qty: 1 });
  return cartWrite(list);
};

export const cartSetQty = (id, qty) => cartWrite(cartRead().map((e) => (e.id === id ? { ...e, qty: Math.max(1, Math.min(99, Number(qty) || 1)) } : e)));

export const cartRemove = (id) => cartWrite(cartRead().filter((e) => e.id !== id));

export const cartClear = () => cartWrite([]);

export const priceOf = (pkg) => Number(String(pkg?.new_price ?? "").replaceAll(",", "")) || 0;
